package com.loyola.acessoescola.ui.registered

import com.loyola.acessoescola.data.JsonOutValues
import com.loyola.acessoescola.services.quintadb.getFileUrl

data class RegisteredState(
    val isLoading: Boolean = true
)

data class RegisteredRecord(
    val imageUrl: String,
    val recordID: String,
    val fullName: String,
    val bound: String
)


fun JsonOutValues.toRegisteredRecord(): RegisteredRecord{
    return RegisteredRecord(
        imageUrl = getFileUrl(recordID = recordID, fileName = jsonValues.photo),
        recordID = recordID,
        fullName = jsonValues.name,
        bound = jsonValues.bound
    )
}